import { Banner, Link } from "@shopify/polaris";

export function PublishBanner() {
  return (
    <Banner
        title={
        <>
             Import your first product to shopify.{" "} 
            <Link url={`${process.env.REACT_APP_BASE_URL}/products`} >Click Here To Proceed</Link>
        </>
        }
        tone="success"
    />
  );
}